import { NgModule } from '@angular/core';
import { AppMessageComponent } from './app-message.component';
import { AppMessagesComponent } from './app-messages.component';

@NgModule({
    imports: [AppMessageComponent, AppMessagesComponent],
    exports: [AppMessageComponent, AppMessagesComponent],
})
export class UiMessageModule {}

